import { CountryRegionDistrictFilter } from './CountryRegionDistrictFilter'
import { RegionDistrictFilter } from './RegionDistrictFilter'
import { ListRequestParams } from 'modules/domain/types'
import { isRussia } from 'env'
import { FC } from 'react'

interface Props {
  updateFilterState: (filterObj: Record<string, any>) => void
  listRequestParams: ListRequestParams
  disabled?: boolean
  hideDistrict?: boolean
}

export const CommonRegionFilter: FC<Props> = ({ listRequestParams, updateFilterState, disabled, hideDistrict }) => {
  return isRussia ? (
    <CountryRegionDistrictFilter
      listRequestParams={listRequestParams}
      updateFilterState={updateFilterState}
      hideDistrict={hideDistrict}
      disabled={disabled}
    />
  ) : (
    <RegionDistrictFilter
      listRequestParams={listRequestParams}
      updateFilterState={updateFilterState}
      hideDistrict={hideDistrict}
      disabled={disabled}
    />
  )
}
